import './media-selector.scss';

import { loadYoutubeApi } from '../../utilities/js/helper';

class MediaSelector {
    constructor (element) {
        this.$media = element;
        this.mediaType = this.$media.getAttribute('data-media');
        this.$video = null;
    }

    initialize () {
        if (this.mediaType === 'youtube') {
            this.$video = this.$media.querySelector('[data-youtube]');
            if (this.isMarketingConsentGiven()) {
                this.loadYoutubePlayer();
            }
        }

        if (this.mediaType === 'video') {
            this.$video = this.$media.querySelector('video');
            this.initHTML5Player();
        }
    }

    isMarketingConsentGiven() {
        const consent = window.Cookiebot?.consent?.marketing;
        return consent === true;
    }

    loadYoutubePlayer() {
        import('../../utilities/js/youtube-player').then(({ YoutubePlayer }) => {
            this.initYoutubePlayer(YoutubePlayer);
        });
    }

    initYoutubePlayer (YoutubePlayer) {
        if (this.$video) {
            const youtubeId = this.$video.getAttribute('data-youtube');
            const $playButton = this.$media.querySelector('[data-media="play"]');
            let buttonActiveState = true;

            if (youtubeId !== '') {
                const videoPlayer = new YoutubePlayer(this.$video, {
                    silent: !!this.$video.getAttribute('data-muted'),
                    autoplay: !!this.$video.getAttribute('data-autoplay'),
                    fullscreen: !!this.$video.getAttribute('data-fullscreen'),
                    loop: !!this.$video.getAttribute('data-loop'),
                    root: this.$media,
                    id: youtubeId,
                    observe: true,
                    onCall: () => this.$media.classList.add('is--shown'),
                    onStart: () => this.$media.classList.add('is--shown'),
                    onEnd: () => {
                        videoPlayer.destroy();
                        this.$media.classList.remove('is--shown');
                        buttonActiveState = true;
                    },
                    onPause: () => console.log('video paused')
                });

                $playButton.addEventListener('keydown', (e) => {
                    if (buttonActiveState) {
                        buttonActiveState = false;

                        const interval = setInterval(() => {
                            const $iframe = this.$video.parentElement.querySelector('iframe');
                            if ($iframe) {
                                $iframe.setAttribute('tabindex', '0');
                                $iframe.focus();
                                clearInterval(interval);
                            }
                        }, 100);
                    }
                });
            }
        }
    }

    initHTML5Player () {
        const autoplay = (this.$video.getAttribute('autoplay') === '');
        const loop = (this.$video.getAttribute('loop') === '');
        const controls = (this.$video.getAttribute('controls') === '');
        const $playButton = this.$media.querySelector('[data-media="play"]');
        const $pauseButton = this.$media.querySelector('[data-media="pause"]');

        if (autoplay) {
            this.$media.classList.add('is--playing');
            this.$video.load();
        }

        if (!loop) {
            this.$video.addEventListener('ended', () => {
                this.$media.classList.remove('is--playing');
                if (!controls) showPlayButton();
            });
        }

        if ($playButton) {
            $playButton.addEventListener('click', () => {
                this.$media.classList.add('is--playing');
                showPauseButton();
                this.$video.play();
            });
        }

        if ($pauseButton) {
            $pauseButton.addEventListener('click', () => {
                this.$media.classList.remove('is--playing');
                showPlayButton();
                this.$video.pause();
            });
        }

        const showPauseButton = () => {
            $playButton.setAttribute('aria-hidden', true);
            $playButton.removeAttribute('tabindex');
            $pauseButton.removeAttribute('aria-hidden');
            $pauseButton.setAttribute('tabindex', 0);
        };

        const showPlayButton = () => {
            $pauseButton.setAttribute('aria-hidden', true);
            $pauseButton.removeAttribute('tabindex');
            $playButton.removeAttribute('aria-hidden');
            $playButton.setAttribute('tabindex', 0);
        };
    }
}

export { MediaSelector };

window.addEventListener('content.loaded', (e) => {
    const { $context } = e.detail || {};

    if ($context) {
        const initMediaSelector = () => {
            const $$medias = $context.querySelectorAll('[data-media]');
            $$medias.forEach(($media) => {
                const mediaAPI = new MediaSelector($media);
                mediaAPI.initialize();
            });
        };

        if (typeof window.YT === 'undefined' && window.CookieConsent.consent.marketing) {
            loadYoutubeApi();
            window.onYouTubeIframeAPIReady = initMediaSelector;
        } else if (window.CookieConsent.consent.marketing) {
            initMediaSelector();
        }

        const checkConsentAndReload = () => {
            if (window.CookieConsent.consent.marketing) {
                location.reload();
            }
        };

        if (window.CookieConsent !== undefined) {
            window.addEventListener('CookiebotOnAccept', checkConsentAndReload);
        }
    }
});
